// src/components/modules/communication.js

import React, { useState } from 'react';

const Communication = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Communication / Social' : 'Communication / Social'}
      </button>
      {isExpanded && (
        <ul>
          <li><a translate="no" href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
          <li><a translate="no" href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a></li>
          <li><a translate="no" href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
          <li><a translate="no" href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          <li><a translate="no" href="https://www.snapchat.com" target="_blank" rel="noopener noreferrer">SnapChat</a></li>
          <li><a translate="no" href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
          <li><a translate="no" href="https://www.discord.com" target="_blank" rel="noopener noreferrer">Discord</a></li>
          <li><a translate="no" href="https://www.wechat.com" target="_blank" rel="noopener noreferrer">WeChat</a></li>
        </ul>
      )}
    </div>
  );
}

export default Communication;